import axios from "axios";

import { manageError } from "../utils/axiosResponseError";
import { showSuccess } from "../utils/configToast";

export const newSubscriptionAction = (postData) => async (dispatch) => {
	let responseData;
	console.log(postData);
	
	await axios
		.post("store/product/subscription", postData)
		.then((res) => {
			responseData = res.data;
			
			let msgSuccess = responseData.message
				? responseData.message
				: "Successfully added";
			showSuccess(msgSuccess);
			responseData = responseData ? responseData : true;
		})
		.catch((error) => {
			manageError(error);
		});
	return responseData;
};
